<!-- eslint-disable max-len -->
<template>
  <div>
    <nav
      class="bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"
      style="height: 50px;"
    >
    </nav>
    <div class="flex flex-col md:flex-row">
      <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-2">
        <div class="bg-blue-800 p-2 shadow text-xl text-white">
          <div class="bg-grey-lighter min-h-screen flex flex-col">

            <!-- eslint-disable max-len -->
            <div
              class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
            >
            <!-- eslint-enable max-len -->
              <div class="bg-white px-6 py-8 rounded shadow-md text-black w-full">
              <h1 class="mb-8 text-3xl text-center">Sign in</h1>
              <form @submit="login" >
                <input
                  type="text"
                  class="block border border-grey-light w-full p-3 rounded mb-4"
                  name="email"
                  placeholder="Email"
                  v-model="email"
                />

                <input
                  type="password"
                  class="block border border-grey-light w-full p-3 rounded mb-4"
                  name="password"
                  placeholder="Password"
                  v-model="password"
                />
                <!-- eslint-disable-next-line max-len -->
                <p v-if="getStatus !== 200" class="text-red-500 text-xs italic text-left">{{ getMessage }}</p>
                <!-- eslint-disable max-len -->
                <button
                  type="submit"
                  @click="login"
                  :disabled="isLoading"
                  class="w-full text-center py-3 rounded bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1"
                >
                  {{ labelSave }}<img v-if="isLoading" src="@/assets/bars.svg" width="30px" class="m-auto" />
                </button>
                <!-- eslint-enable max-len -->
              </form>
              <div class="text-center text-sm text-grey-600 mt-4">
                <a class="no-underline border-b border-grey-600 text-grey-600" href="#">
                  Forgot Password?
                </a>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SigninAdmin',
  data: () => ({
    email: '',
    password: '',
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    labelSave() {
      return !this.isLoading ? 'Login' : '';
    },
  },
  methods: {
    ...mapActions('AuthModule', ['requestAuthentication']),
    async login(e) {
      e.preventDefault();
      try {
        // eslint-disable-next-line max-len
        const response = await this.requestAuthentication({ user: { email: this.email, password: this.password }, isAdmin: true });
        if (response) {
          this.$router.push({ name: 'Dashboard' });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/SigninAdmin.vue